import React from 'react'
import { useSelector } from 'react-redux'
import IToken from '../../images/token.png'
import IInfo from '../../images/info.png'
import { NAME_TOKEN } from '../../constants'

interface IProps {
  mininumRate: string
  onClickConfirm: () => void
  setShowModalInfo: (data: boolean) => void
}

const ConfirmForm = ({
  mininumRate,
  onClickConfirm,
  setShowModalInfo,
}: IProps) => {
  const tokenState = useSelector((state) => state.token)

  const isActive = React.useMemo(() => {
    return Number(tokenState.balanceOfToken) > Number(mininumRate)
  }, [tokenState.balanceOfToken, mininumRate])

  return (
    <div className='confirm-stake-container'>
      <div className='card-confirm-stake'>
        <div className='card-confirm-stake--header'>
          <h5 color='text' className='text-topic  font-weight-bold'>
            One Pirate Referral Program
          </h5>
        </div>
        <div className='card-confirm-stake--content'>
          <p className='text-title'>
            Stake 10,000 OneP to begin the One Pirate Referral Program, you can
            unstake this 10,000 OneP when you want to leave the referral
            program.
          </p>
          <div className='d-flex flex-column mt-5'>
            <div className='d-flex justify-content-end text-content mb-1'>
              Balance: {tokenState.balanceOfToken} OneP
            </div>
            <div className='box-mininum-rate'>
              <span className='text-topic'>{mininumRate}</span>
              <div className='icon-token'>
                <img alt='' src={IToken} />
                <div className='text-icon'>{NAME_TOKEN}</div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-center mt-5'>
            <button
              className={`btn secondary-btn btn-confirm`}
              onClick={onClickConfirm}
              disabled={!isActive}
            >
              {isActive ? 'Stake' : 'Insufficient'}
            </button>
          </div>
          <div className='d-flex justify-content-center mt-3'>
            <p className='text-content'>Why you need to staking</p>
            <button
              className='icon-info'
              onClick={() => setShowModalInfo(true)}
            >
              <img alt='' src={IInfo} />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConfirmForm
